import { render, staticRenderFns } from "./ViewAssociatedProperty.vue?vue&type=template&id=cfa64f5a"
import script from "./ViewAssociatedProperty.vue?vue&type=script&lang=js"
export * from "./ViewAssociatedProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports